import axios from '../config/api'

const state = () => ({
  modelTradeIn: [],
  modelTradeInTopUp: [],
  isLoading: false,
})

const getters = {
  getModelTradeIn: state => {
    return state?.modelTradeIn ?? []
  },
  getModelTradeInTopUp: state => {
    return state?.modelTradeInTopUp ?? []
  },
}

const actions = {
  getAdditionalSamsungForm({ commit, state }) {
    if (state.modelTradeIn.length > 0) {
      return
    }

    commit('setAdditionalFormSamsung')
    axios
      .get('/dropdown/model-tradein-samsung')
      .then(response => {
        commit('setAdditionalFormSamsungSuccess', response.data)
      })
      .catch(err => {
        commit('setAdditionalFormSamsungError', err)
      })
  },

  async getAdditionalSamsungFormTopup({ commit, state }) {
    if (state.modelTradeInTopUp.length > 0) {
      return
    }

    commit('setAdditionalFormSamsungTopUp')
    await axios
      .get('/dropdown/model-tradein-samsung-topup')
      .then(response => {
        commit('setAdditionalFormSamsungTopUpSuccess', response.data)
      })
      .catch(err => {
        commit('setAdditionalFormSamsungTopUpError', err)
      })
  },
}

const mutations = {
  setAdditionalFormSamsung(state) {
    state.modelTradeIn = []
    state.isLoading = true
  },
  setAdditionalFormSamsungSuccess(state, item) {
    state.modelTradeIn = item
    state.isLoading = false
  },
  setAdditionalFormSamsungError(state, value) {
    state.modelTradeIn = value
    state.isLoading = false
  },
  setAdditionalFormSamsungTopUp(state) {
    state.modelTradeInTopUp = []
    state.isLoading = true
  },
  setAdditionalFormSamsungTopUpSuccess(state, item) {
    state.modelTradeInTopUp = item
    state.isLoading = false
  },
  setAdditionalFormSamsungTopUpError(state, value) {
    state.modelTradeInTopUp = value
    state.isLoading = false
  },
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
}
